import { AnyOperationLogEntityVersion, Cached, Collections } from '@uploadcam/common';
import { CollectionReference, Firestore } from 'firebase/firestore';
import { getCollectionRef } from '../../@harmony/angular';
import { CreateOperationLogInteractor } from './domain/interactors/create-operation-log.interactor';
import { DeleteOperationLogInteractor } from './domain/interactors/delete-operation-log.interactor';
import { SetOperationLogStateInteractor } from './domain/interactors/set-operation-log-state.interactor';
import { AuthProvider } from '../auth/auth.provider';

export abstract class OperationLogsProvider {
  abstract provideCreateOperationLog(): CreateOperationLogInteractor;
}

export class OperationLogsDefaultProvider implements OperationLogsProvider {
  private readonly operationLogsCollection: CollectionReference<AnyOperationLogEntityVersion>;

  constructor(
    private readonly authProvider: AuthProvider,
    firestore: Firestore,
  ) {
    this.operationLogsCollection = getCollectionRef(firestore, Collections.OperationLogs);
  }

  @Cached()
  public provideCreateOperationLog(): CreateOperationLogInteractor {
    return new CreateOperationLogInteractor(
      this.operationLogsCollection,
      this.authProvider.provideGetCredential(),
      this.authProvider.provideGetUser(),
      new DeleteOperationLogInteractor(this.operationLogsCollection),
      new SetOperationLogStateInteractor(this.operationLogsCollection),
    );
  }
}
